export const ID = '1aa0ceb1-798c-416a-9174-9286720db657';

export const NAME = 'Translate: Google';
